export default {"src":"/_next/static/media/artwork.ab71b903.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};